import { useSelector } from 'react-redux';
import {
  isRegisteredUser,
  getConfirmedPurchaseInformation,
  getSelectedSubscriptionPlan,
  isPurchaseSubscriptionFailed,
  hasSubscription,
  getCurrentUser
} from 'redux/query';
import { useMemo } from 'react';
import { SUBSCRIPTION_PLAN_GROUPS } from 'utils/subscriptionPlanGroups';
import { linkHandler } from 'utils/linkHandler';

export const useCheckoutRefererRoute = () => {
  const userRegistered = useSelector(isRegisteredUser);
  const isSubscribed = useSelector(hasSubscription);
  const selectedSubscriptionPlan = useSelector(getSelectedSubscriptionPlan);
  const { isGiftCoupon, confirmedPurchase, autoAssigned } = useSelector(getConfirmedPurchaseInformation);
  const hasError = useSelector(isPurchaseSubscriptionFailed);
  const user = useSelector(getCurrentUser);

  const isSelectedPlanGiftCoupon =
    !!selectedSubscriptionPlan && selectedSubscriptionPlan.subscriptionPlanGroup === SUBSCRIPTION_PLAN_GROUPS.GIFT;

  const activeZppCourses = useMemo(
    () => (user?.activeSubscriptionPlans || []).filter((plan) => plan.zppCertified).map((plan) => plan.zppCourseGroupSlug),
    [user?.activeSubscriptionPlans]
  );

  return useMemo(() => {
    if (hasError) {
      return linkHandler.get('paymenterror');
    }

    if (confirmedPurchase) {
      if (isGiftCoupon) {
        return linkHandler.get('thankyougift');
      }
      if (userRegistered) {
        return linkHandler.get('thankyou');
      }
      if (autoAssigned) {
        return linkHandler.get('thankyoupurchaseassociated');
      }
      return linkHandler.get('thankyouloggedout');
    }
    if (!selectedSubscriptionPlan) {
      return linkHandler.get('plans');
    }
    if (
      selectedSubscriptionPlan.zppCertified &&
      activeZppCourses.length < 2 &&
      !activeZppCourses.includes(selectedSubscriptionPlan.zppCourseGroupSlug)
    ) {
      return null;
    }

    if ((!selectedSubscriptionPlan.zppCertified && !!activeZppCourses.length) || (isSubscribed && !isSelectedPlanGiftCoupon)) {
      return linkHandler.get('profilePersonalData');
    }

    return null;
  }, [
    hasError,
    activeZppCourses,
    userRegistered,
    selectedSubscriptionPlan,
    isGiftCoupon,
    confirmedPurchase,
    isSubscribed,
    isSelectedPlanGiftCoupon,
    autoAssigned
  ]);
};
